import React from 'react';
import { Divider } from 'semantic-ui-react'

const VerPerfil1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel, handleClickSel1}) => {
  const a200505 = autorizacUA.findIndex( autorizac => autorizac === "200505" );
  const a200510 = autorizacUA.findIndex( autorizac => autorizac === "200510" );
  const a200515 = autorizacUA.findIndex( autorizac => autorizac === "200515" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a200505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      {a200510!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }

      {a200515!==-1 &&
      <div>
      <Divider inverted />

      <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
        <i className="large settings yellow icon"></i>
        Configurar
      </button>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large check violet icon"></i>
        Autorizaciones
      </button>
      </div>
      }

      <Divider inverted />

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerPerfil1
